import { makeStyles } from '@mui/styles';

const style = makeStyles((theme?: any) => ({
  segment: {
    marginTop: theme.spacing(9),
    marginBottom: theme.spacing(14),
  },
  imgContainer: {
    backgroundColor: '#5f2afa',
    marginBottom: theme.spacing(2),
  },
  mainHeading: {
    paddingBottom: theme.spacing(7),
  },
  card: {
    padding: theme.spacing(3),
    '& a': {
      display: 'inline-block',
    },
    '&:hover': {
      '& h4': {
        color: theme.palette.primary.main,
      },
    },
  },
  [theme.breakpoints.up('md')]: {
    segment: {
      marginTop: theme.spacing(11),
      marginBottom: theme.spacing(11),
    },
  },
}));

export default style;
